<template>
  <div v-if="currentUser && currentUser.role_id === 5" class="specialist-add-page">
    <div class="page-header">
      <div>
        <h1>Dodaj specjalistę</h1>
        <p>Wyślij zaproszenie do specjalisty, którego chcesz przypisać do placówki.</p>
      </div>

      <RouterLink to="/firm-profile/specialists" class="header-link">
        <button class="btn-outline">Wróć do listy</button>
      </RouterLink>
    </div>

    <div class="layout">
      <section class="section-card invite-card">
        <div class="card-heading">
          <h2>Zaproszenie</h2>
          <p>Podaj adres e-mail specjalisty. Po wysłaniu zaproszenia specjalista będzie musiał je zaakceptować.</p>
        </div>

        <form class="invite-form" @submit.prevent="email ? sendConfirm = true : appStore.setIsAlert('Podaj adres e-mail specjalisty')">
          <label for="specialistEmail">Adres e-mail specjalisty</label>
          <input
              type="email"
              id="specialistEmail"
              v-model="email"
              placeholder="adres e-mail"
              aria-label="podaj adres e-mail"
              required
          >

          <button type="submit" class="btn-primary">
            Wyślij zaproszenie
          </button>
        </form>

        <div class="confirm-card" v-if="sendConfirm">
          <h3>Czy na pewno wysłać zaproszenie?</h3>
          <p>Zaproszenie zostanie wysłane na adres: <strong>{{ email }}</strong></p>

          <div class="confirm-actions">
            <button class="btn-outline" @click="sendConfirm = false">Nie</button>
            <button class="btn-primary" @click="sendInvitation()">Tak</button>
          </div>
        </div>
      </section>

      <aside class="section-card help-card">
        <h2>Informacja</h2>
        <ul>
          <li>Specjalista pojawi się na liście po wysłaniu zaproszenia.</li>
          <li>Status aktywny oznacza, że zaproszenie zostało zaakceptowane.</li>
          <li>Specjalistę możesz później usunąć z listy zarządzania.</li>
        </ul>
      </aside>
    </div>
  </div>

  <div v-else class="fallback">
    <h2>Błąd wczytywania. Spróbuj ponownie.</h2>
  </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import axios from 'axios';
import authHeader from '@/services/auth-header';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default {
  name: 'SpecialistAdd',
  data() {
    return {
      email: '',
      sendConfirm: false
    };
  },
  setup() {
    useMeta({ title: 'specjaliści' });

    return {
      authStore: useAuthStore(),
      appStore: useAppStore()
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    }
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 5) {
      this.$router.push('/login');
    }
  },
  methods: {
    sendInvitation() {
      axios.post('/AddBusinessToFirm', {
        email: this.email
      }, authHeader()).then((res) => {
        if (res && res.status == 200) {
          this.appStore.setIsSuccess('Wysłano zaproszenie do specjalisty');
          this.sendConfirm = false;
          this.$router.push('/firm-profile/specialists');
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.specialist-add-page {
  background: #ffffff;
  min-height: 100vh;
  padding: 24px 16px 32px;
  color: #1f2937;
}

.page-header {
  max-width: 1200px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  border-bottom: 2px solid #e5e7eb;
  padding-bottom: 14px;
}

.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  font-weight: 700;
}

.page-header p {
  margin: 4px 0 0;
  color: #6b7280;
  font-size: 1.4rem;
}

.header-link {
  text-decoration: none;
}

.layout {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 20px;
  align-items: flex-start;
  flex-wrap: wrap;
}

.section-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 16px;
  box-sizing: border-box;
}

.invite-card {
  flex: 1 1 0;
  min-width: 0;
}

.help-card {
  width: 320px;
  flex-shrink: 0;
  background: #fff7ed;
  border-color: #fed7aa;
}

.card-heading {
  margin-bottom: 16px;
}

.card-heading h2,
.help-card h2 {
  margin: 0 0 6px;
  font-size: 2rem;
}

.card-heading p {
  max-width: 720px;
  margin: 0;
  color: #6b7280;
  font-size: 1.35rem;
  line-height: 1.5;
}

.invite-form {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;
}

.invite-form label {
  font-size: 1.35rem;
  color: #374151;
}

.invite-form input {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 1.4rem;
  box-sizing: border-box;
  outline: none;
  transition: 0.2s;
}

.invite-form input:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.12);
}

.invite-form .btn-primary {
  align-self: flex-start;
  margin-top: 8px;
}

.confirm-card {
  margin-top: 16px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 14px;
}

.confirm-card h3 {
  margin: 0 0 6px;
  font-size: 1.7rem;
}

.confirm-card p {
  margin: 0;
  color: #374151;
  font-size: 1.35rem;
  line-height: 1.5;
  word-break: break-word;
}

.confirm-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 12px;
}

.help-card ul {
  margin: 0;
  padding-left: 18px;
  color: #7c2d12;
  font-size: 1.35rem;
  line-height: 1.6;
}

.btn-primary,
.btn-outline {
  border-radius: 8px;
  font-size: 1.35rem;
  cursor: pointer;
}

.btn-primary {
  background: #f97316;
  color: #ffffff;
  border: none;
  padding: 10px 14px;
  font-weight: 600;
}

.btn-primary:hover {
  background: #ea6c0a;
}

.btn-outline {
  background: #ffffff;
  color: #1f2937;
  border: 1px solid #d1d5db;
  padding: 10px 14px;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

.fallback {
  padding: 24px;
  text-align: center;
}

@media (max-width: 980px) {
  .layout {
    flex-direction: column;
  }

  .help-card {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .specialist-add-page {
    padding: 16px 12px 24px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .header-link,
  .btn-primary,
  .btn-outline {
    width: 100%;
  }

  .btn-primary,
  .btn-outline {
    text-align: center;
  }

  .invite-form .btn-primary {
    align-self: stretch;
  }

  .confirm-actions {
    width: 100%;
  }

  .confirm-actions button {
    flex: 1;
  }
}
</style>